import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreatePromoCode = () => {
  return (
    <Create
      title='Create Promo Code'
      fields={fields}
      apiPath='admin/promo_codes'
      successRedirectPath={(resource) => `/ecommerce/promo-codes/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreatePromoCode
